import { useTranslation } from 'react-i18next';

import { FormCheckbox } from '~/components/atoms/form-fields/FormCheckbox';
import { FormTextField } from '~/components/atoms/form-fields/FormTextField';
import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlock from '~/components/builder/NameAndOrganizationBlock';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import Accordion from '~/components/ui/Accordion/Accordion';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { StyledContentContainer, StyledFormContainer } from '~/pages/qrBuilder/p-static/commonStyled';
// import PasswordProtectionBlock from '~/components/builder/PasswordProtectionBlock';

export const StaticWifiForm = () => {
  const { t } = useTranslation();

  return (
    <StyledFormContainer>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_STATIC_TYPE.WIFI} />
      <CreateQRContentBlockLayout defaultExpanded type="basicInfo">
        <Accordion
          defaultExpanded
          variant="child"
          hideBottomBorder
          summary={t('staticQrTemplates:wifi:content:title')}
          details={
            <StyledContentContainer>
              <FormTextField
                name="ssid"
                fullWidth
                label={t('staticQrTemplates:wifi:content:fields:ssid:label')}
                placeholder={t('staticQrTemplates:wifi:content:fields:ssid:placeholder')}
                inputProps={{ maxLength: 100 }}
              />
              <FormTextField
                name="password"
                fullWidth
                label={t('staticQrTemplates:wifi:content:fields:password:label')}
                placeholder={t('staticQrTemplates:wifi:content:fields:password:placeholder')}
                inputProps={{ maxLength: 100 }}
              />
              <FormTextField
                name="authType"
                fullWidth
                label={t('staticQrTemplates:wifi:content:fields:authType:label')}
                select
                options={[
                  { label: 'WEP', value: 'WEP' },
                  { label: 'WPA', value: 'WPA' },
                  { label: 'WPA2-EAP', value: 'WPA2-EAP' },
                  { label: 'nopass', value: 'nopass' },
                ]}
                defaultValue="'WEP'"
              />
              <FormCheckbox name="hidden" label={t('staticQrTemplates:wifi:content:fields:hidden:label')} />
            </StyledContentContainer>
          }
        />
      </CreateQRContentBlockLayout>
      <NameAndOrganizationBlock isStatic />
      {/*<PasswordProtectionBlock />*/}
    </StyledFormContainer>
  );
};
